<template>
	<el-select v-model="id" filterable remote clearable placeholder="请选择" size="mini" :remote-method="queryHandleUserList" :loading="loading">
		<el-option v-for="(option, i) in list" :key="i" :label="option.name + '(' + option.id + ')'" :value="option.id" />
	</el-select>
</template>

<script>
export default {
	data () {
		return {
			id: null,
			loading: false,
			list: []
		}
	},
	props: {
		value: {
			default: null
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val !== this.id) {
					this.id = val
					if (this.id && !this.list.length) {
						this.getProcessingUserName([this.id]).then(res => {
							this.list = res
						})
					}
				}
			},
			immediate: true
		},
		id: {
			handler(val) {
				if (val !== this.value) {
					this.$emit('input', val)
					this.$emit('change', val)
				}
			}
		}
	},
	methods: {
		// 查询处理人列表
		queryHandleUserList(query) {
			this.loading = false;
			this.interval && clearTimeout(this.interval);

			if (query !== '') {
				this.interval = setTimeout(() => {
					this.loading = true;
					let data = {
						key: query
					}
					this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketUserApi.search', data).then(result => {
						this.loading = false;
						this.list = result.data;
					}, response => {
						this.loading = false;
					});
				}, 200)
			} else {
				this.list = [];
			}
		},

		// 获取处理人姓名
		getProcessingUserName (ids) {
			return new Promise((resolve, reject) => {
				let data = { ids }
				this.$axios.post(API_ROOT.sUrl + '/ticket/api/TicketUserApi.listByIdsCached', data).then(result => {
					if (result.status) {
						resolve(result.data)
					} else {
						this.$alert('获取处理人姓名失败，失败原因：' + (result.msg || result.message));
						reject()
					}
				}, response => {
					this.$alert('获取处理人姓名失败，错误码(' + response + ')');
					reject()
				})
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/aside/queryTjkUserSelect.vue